export enum PersonalIdentityType {
  CustomerId = 'CustomerId',
  PassportNumber = 'PassportNumber',
}
